import { UpsertPartnerQuoteInfoRequest } from "../../api/types/upsert-partner-quote-info-request";

export const generateNotes = (upsertQuoteInputs: UpsertPartnerQuoteInfoRequest): string => {
    let notes: string[] = [];

    if (upsertQuoteInputs.quoteOutcome === "Quote" && upsertQuoteInputs.primaryOutcomeType === "Not sold (offered to the customer)") {
        if (upsertQuoteInputs.firstName) notes.push(`First Name: ${upsertQuoteInputs.firstName}`);
        if (upsertQuoteInputs.lastName) notes.push(`Last Name: ${upsertQuoteInputs.lastName}`);
        
        if (upsertQuoteInputs.lineOfBusiness === "Commercial Auto") {
            notes.push("CAU Decline Reason:");
            if (upsertQuoteInputs.source) notes.push(`Partner: ${upsertQuoteInputs.source}`);
            if (upsertQuoteInputs.referenceNumber) notes.push(`Quote Number: ${upsertQuoteInputs.referenceNumber}`);
        }

        if (upsertQuoteInputs.source && !["GEICO_SSP", "GEICO_ICLIQ"].includes(upsertQuoteInputs.source)) {
            if (upsertQuoteInputs.businessClassDescription) notes.push(`Business Class: ${upsertQuoteInputs.businessClassDescription}`);
            if (upsertQuoteInputs.source) notes.push(`Source: ${upsertQuoteInputs.source}`);
            if (upsertQuoteInputs.referenceNumber && upsertQuoteInputs.lineOfBusiness !== "Commercial Auto") {
                notes.push(`Quote Number: ${upsertQuoteInputs.referenceNumber}`);
            }
        }
    }

    if (upsertQuoteInputs.quoteOutcome === "Sale") {
        if (["GEICO_SSP", "GEICO_ICLIQ", "TRAVELERS"].includes(upsertQuoteInputs.source)) {
            if (upsertQuoteInputs.lineOfBusiness === "Commercial Auto") {
                notes.push("Customization of Each Vehicle:");
                notes.push("Risk Details (include multiclass):");
                notes.push("Sup Initials: PA Option Forms, GVW, MVR/CLUE, bundling:");
            }
        }

        if (upsertQuoteInputs.source === "BHHC" || upsertQuoteInputs.source === "NICO") {
            notes.push("Brief vehicle usage desc:");
            notes.push("Customization of Each Vehicle:");
            notes.push("Is this your primary business, if no, explain:");
            notes.push("List all types of cargo:");
            notes.push("Gross Receipts: last & next year:");
            notes.push("Largest City Entered:");
            if (upsertQuoteInputs.policyNumber) notes.push(`Policy Number: ${upsertQuoteInputs.policyNumber}`);
        }

        if (upsertQuoteInputs.source && !["GEICO_SSP", "GEICO_ICLIQ", "NICO", "BHHC"].includes(upsertQuoteInputs.source)) {
            if (upsertQuoteInputs.policyNumber) notes.push(`Policy Number: ${upsertQuoteInputs.policyNumber}`);
            if (upsertQuoteInputs.soldPremium) notes.push(`Premium: ${upsertQuoteInputs.soldPremium}`);
            notes.push("UW Submits / Sup Approvals:");
            if (upsertQuoteInputs.source === "CNA_SURETY") {
                notes.push(`Payment Confirmation Number: ${upsertQuoteInputs.paymentConfirmationNumber}`);
            }
        }
    }

    return notes.join("\n");
};